import { render } from "./BubbleTea.vue?vue&type=template&id=5be4804e&scoped=true"
import script from "./BubbleTea.vue?vue&type=script&lang=js"
export * from "./BubbleTea.vue?vue&type=script&lang=js"

import "./BubbleTea.vue?vue&type=style&index=0&id=5be4804e&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be4804e"]])

export default __exports__